import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4451a2ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-section" }

import SearchPanel from '@/searchSection/components/SearchPanel/SearchPanel.vue'
import SearchResults from "@/searchSection/components/SearchResults/SearchResults.vue";
import StartArrow from "@/searchSection/components/StartArrow/StartArrow.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchSection',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SearchPanel),
    _createVNode(SearchResults),
    _createVNode(StartArrow)
  ]))
}
}

})